// Project picker ranking (architecture sprint-03 §9.4): match weight × (1 + own usage).
import { matchWeight } from '@shared/match';
import type { PersonalProject } from '@/types/projects';

export const NO_PROJECT_LABEL = 'No project';

export type PickerOption = { kind: 'none' } | { kind: 'project'; project: PersonalProject };

/**
 * "No project" first whenever the query is empty or matches it; then projects with weight > 0,
 * by score = weight × (1 + ownEntryCount) DESC, then name (English, case/accent-insensitive).
 */
export function rankProjects(projects: readonly PersonalProject[], query: string): PickerOption[] {
  const ranked = projects
    .map((project) => ({ project, weight: matchWeight(project.name, query) }))
    .filter((r) => r.weight > 0)
    .map((r) => ({ project: r.project, score: r.weight * (1 + r.project.ownEntryCount) }))
    .sort((a, b) => b.score - a.score || a.project.name.localeCompare(b.project.name, 'en', { sensitivity: 'base' }))
    .map((r): PickerOption => ({ kind: 'project', project: r.project }));
  const showNone = query.trim() === '' || matchWeight(NO_PROJECT_LABEL, query) > 0;
  return showNone ? [{ kind: 'none' }, ...ranked] : ranked;
}
